module.exports = __webpack_public_path__ + "fonts/9b190ca.woff";